import { Box, TableCell, TableRow, Tooltip, Typography } from '@mui/material'
import { FC } from 'react'
import { getFeatureDisplayName, getFeatureNameTestId, SopFeatureRow } from './utils'
import { MISSING_VALUE } from '../../../../constants'
import { useRouteLocation } from '../../../../hooks/useRouteLocation'
import { formatIsoTimestampForLocation } from '../../../../utils/dateUtils'

interface FeatureTableEntryProps {
  feature: SopFeatureRow
}

export const FeatureTableEntry: FC<FeatureTableEntryProps> = ({ feature }) => {
  const location = useRouteLocation()

  const originalFeatureName = feature.name || MISSING_VALUE
  const displayFeatureName = getFeatureDisplayName(feature.name)
  const shouldShowTooltip = Boolean(feature.name)

  return (
    <TableRow data-testid={getFeatureNameTestId(feature.name)}>
      <TableCell>
        {shouldShowTooltip ? (
          <Tooltip title={originalFeatureName} arrow placement="bottom-start">
            <Box
              component="span"
              sx={{
                cursor: 'help'
              }}
            >
              {displayFeatureName}
            </Box>
          </Tooltip>
        ) : (
          displayFeatureName
        )}
        {feature.note && (
          <Typography variant="caption" component="div" color="text.secondary" data-testid={`${getFeatureNameTestId(feature.name)}-note`}>
            {feature.note}
          </Typography>
        )}
      </TableCell>
      <TableCell>{feature.enabled ? 'Yes' : 'No'}</TableCell>
      <TableCell>{feature.consent?.acceptedBy || MISSING_VALUE}</TableCell>
      <TableCell data-testid={`${getFeatureNameTestId(feature.name)}-accepted-at`}>
        {feature.consent?.acceptedAt ? formatIsoTimestampForLocation(feature.consent.acceptedAt, location) : MISSING_VALUE}
      </TableCell>
    </TableRow>
  )
}
